import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import Input from '../#Input';
import IconButton from '../../buttons/IconButton';

export const StyledInputWrapper = styled.span<{ inputWidth: number; isUnionControlGroup: boolean }>`
  position: relative;
  display: flex;
  width: ${({ inputWidth }) => inputWidth ? `${inputWidth}px` : 'auto'};
  ${({ isUnionControlGroup }) => isUnionControlGroup && css`
    display: inline;
    &:first-child {
      ${StyledInput} {
        border-top-left-radius: ${({ theme }) => theme?.Input?.borderRadius};
        border-bottom-left-radius: ${({ theme }) => theme?.Input?.borderRadius};
      }
    }
    &:nth-last-child(1) {
      ${StyledInput} {
        border-top-right-radius: ${({ theme }) => theme?.Input?.borderRadius};
        border-bottom-right-radius: ${({ theme }) => theme?.Input?.borderRadius};
      }
    }
  `}
`;

export interface StyledInputProps {
  leftSign?: ReactNode;
  leftSignWidth?: number;
  isValid?: boolean;
  hasWarning?: boolean;
  hasCaution?: boolean;
  isTouched?: boolean;
  readOnly?: boolean;
  rightSign?: ReactNode;
  rightSignWidth?: number;
  clearButton?: boolean;
}

export const StyledInput = styled(Input)<StyledInputProps>`
  cursor: text;
  &::-ms-reveal, ::-ms-clear { display: none; }


  ${({ theme, leftSign, leftSignWidth }) => leftSign && css<StyledInputProps>`
    padding-left: ${leftSignWidth}px;

    &:not(:disabled):focus {
      padding-left: ${leftSignWidth + theme.Input.signFocusOffset}px;
    }

    &:not(:disabled) {
      ${({ isValid, hasWarning, hasCaution, isTouched, readOnly }) => (!readOnly && (!isValid || hasWarning || hasCaution) && isTouched) && css`
        padding-left: ${leftSignWidth + theme.Input.signFocusOffset}px;
      `}
    }
  `}

  ${({ clearButton, rightSign }) => !rightSign && clearButton && css<StyledInputProps>`
    padding-right: 44px;
  `}

  ${({ theme, rightSign, rightSignWidth, clearButton }) => rightSign && css<StyledInputProps>`
    padding-right: ${rightSignWidth + (clearButton ? 50 : 0)}px;

    &:not(:disabled):focus {
      padding-right: ${rightSignWidth + theme.Input.signFocusOffset + (clearButton ? 50 : 0)}px;
    }

    &:not(:disabled) {
      ${({ isValid, hasWarning, hasCaution, isTouched, readOnly }) => (!readOnly && (!isValid || hasWarning || hasCaution) && isTouched) && css`
        padding-right: ${rightSignWidth + theme.Input.signFocusOffset + (clearButton ? 50 : 0)}px;
      `}
    }
  `}
`;

export const StyledSign = styled.span<{ clickable: boolean; right?: boolean }>`
  position: absolute;
  font-size: 14px;
  height: 100%;
  padding: 11px 10px;
  box-sizing: border-box;
  line-height: 1.29;
  ${({ clickable }) => !clickable && css`
    pointer-events: none;
  `}

  ${({ right }) => right && css`
    right: 0;
  `}
`;

export const StyledClearButton = styled(IconButton)<{ rightSignWidth: number; rightSign?: ReactNode }>`
  position: absolute;
  right: 0;
  top: -2px;
  color: ${({ theme }) => theme.colors.gray5};

  &:hover {
    color: ${({ theme }) => theme.colors.gray6};
  }

  &:active:not(:disabled) {
    color: ${({ theme }) => theme.colors.gray4};
  }

  ${({ rightSignWidth, rightSign }) => rightSign && css`
    right: ${rightSignWidth + 6}px;
  `}
`;
